<template>
<el-container>
  <div v-if="common.isMobile() === false">
    <publicHeader ref="child"></publicHeader>
  </div>
  <div v-else>
    <div style="height:60px; background-color:rgba(79, 76, 76, 1);">
      <router-link :to="{name:'Home', params: {'querys': common.linkEncode({'source': source, 'conver': conver}, 'obj')}}">
        <i class="el-icon-arrow-left" style="color: white;height: 20px; width: 20px; font-size: 20px; position: absolute;margin: 20px 0px 20px 20px;"></i>
      </router-link>
      <div style="font-weight: 650; font-style: normal; font-size: 16px; color: #FFFFFF; text-align: center; height: 60px; line-height: 60px;">{{$t('setPassword')}}</div>
    </div>
  </div>
  <el-main :class="{'top-pc': common.isMobile() === false}">
      <div class="forget-main">
        <div class="forget-info">
          <div style="padding:6%;padding-bottom: 12%;">
            <div class="forgettext">{{$t('setPassword')}}</div>
            <div class="login-remind" v-show="remindSuccess">
              <div class="login-remindinfo">
                <div class="login-img">
                  <img src="https://res.roompai.com/static/img/account/my-payment-yes.png" style="width:12px; height:12px;display: block;margin: 3px auto;">
                </div>
                <div class="login-remind-text">{{$t('linkToResetYoutPasswordSend')}} {{inputEmail}} {{$t('pleaseCheckYoutEmail')}}</div>
              </div>
            </div>
            <div class="login-remind-faild" :class="{'faild': verifyFail}" v-show="passFail">
              <div class="login-remindinfo">
                <div class="login-img-faild">
                  <img src="https://res.roompai.com/static/img/account/my-error.png" style="width:12px; height:12px;display: block;margin: 3px auto;">
                </div>
                <div class="login-remind-text-faild">{{$t('userEmailVerifyFail')}}</div>
              </div>
            </div>
            <form class="el-form demo-ruleForm forget-form">
              <div style="margin-top:40px;">
                <div class="forget-name">{{$t('electronEmail')}}</div>
                <div class="el-form-item__content">
                  <div class="el-input">
                    <input type="text" autocomplete="off" class="el-input__inner" :value="inputEmail" disabled="true" :class="{'codeError':emailError}" ref="email" :placeholder="$t('electronEmail')">
                  </div>
                </div>
              </div>
              <div style="margin-top:20px;">
                <div class="login-name">{{$t('password')}}</div>
                <div class="el-form-item__content">
                  <div class="el-input">
                    <el-input :type="eyeOpen === true ? 'password' : 'text'" v-model="pwdInput" :placeholder="$t('password')" :class="{'codeError':pwdError}"  v-on:input="search" @focus="showPassImg = true" @blur="showPassImg === true ? showPassImg = true : showPassImg = false" tabindex="2"></el-input>
                    <img :src="eyeOpen === true ? eyeCloseImg : eyeOpenImg" class="eye" v-show="showPassImg" @click="eyeOpen === true ? eyeOpen = false : eyeOpen = true">
                  </div>
                </div>
              </div>
              <div style="margin-top:20px;">
                <div class="login-name">{{$t('retypePassword')}}</div>
                <div class="el-form-item__content">
                  <div class="el-input">
                    <el-input :type="reEyeOpen === true ? 'password' : 'text'" v-model="retypePwdinput" :placeholder="$t('password')" :class="{'codeError':retypePwdError}" v-on:input="search" @focus="showRePassImg = true" @blur="showRePassImg === true ? showRePassImg = true : showRePassImg = false" tabindex="2"></el-input>
                    <img :src="reEyeOpen === true ? eyeCloseImg : eyeOpenImg" class="eye" v-show="showRePassImg" @click="reEyeOpen === true ? reEyeOpen = false : reEyeOpen = true">
                  </div>
                </div>
              </div>
              <div style="margin-top:20px;">
                <el-button  :class="{'forget_send':!forget_send_show, 'forget_send_active':forget_send_show}" @click="submitForm()" data-index="forget-button">{{$t('confirm')}}</el-button>
              </div>
            </form>
          </div>
        </div>
      </div>
  </el-main>
  <publicFooter></publicFooter>
</el-container>
</template>

<script>
import { emailChangePassword, emailRetype } from '@/request/login.js'
import publicFooter from '@/components/public/publicFooter'
import publicHeader from '@/components/public/publicHeader'
export default {
  name: 'resetPassword',
  components: {
    publicFooter,
    publicHeader
  },
  data () {
    return {
      passFail: false,
      verifyFail: false,
      remindSuccess: false,
      emailError: false,
      pwdError: false,
      retypePwdError: false,
      inputEmail: '',
      forget_send_show: false,
      source: 'roompai',
      pwdInput: '',
      retypePwdinput: '',
      eyeOpenImg: '/static/img/login/open-eye.png',
      eyeCloseImg: '/static/img/login/close-eye.png',
      showPassImg: false,
      eyeOpen: true,
      showRePassImg: false,
      reEyeOpen: true,
      conver: ''
    }
  },
  beforeCreate () {
  },
  created: function () {
  },
  mounted () {
    var source = this.common.linkQuerys.source
    // 过期时间 5个小时
    if (source !== '' && source !== undefined && source !== null) {
      this.source = source
      var sourceExpiresAt = Date.now() + 3600000 * 5
      localStorage.setItem('source', this.source)
      localStorage.setItem('sourceExpiresAt', sourceExpiresAt)
    } else {
      localStorage.removeItem('source')
      localStorage.removeItem('sourceExpiresAt')
    }

    var conver = this.common.linkQuerys.conver
    if (conver === 1 || conver === '1') {
      this.conver = conver
    }

    this.emailRetype()
    // 下拉框关闭
    document.addEventListener('click', this.bodyCloseMenus)
  },
  beforeDestroy () {
    document.removeEventListener('click', this.bodyCloseMenus)
  },
  methods: {
    submitForm () {
      this.forget_send_show = true
      this.emailError = false
      this.pwdError = false
      this.retypePwdError = false

      var email = this.$refs['email'].value
      var pwdinput = this.pwdInput
      var retypePwdinput = this.retypePwdinput

      if (email === '' || email === null) {
        this.emailError = true
        return ''
      } else {
        var pattern = /^([a-zA-Z]|[0-9])(\.|\w|-)+@([a-zA-Z0-9])(\.|\w|-)+\.([a-zA-Z]{2,4})$/
        if (!pattern.test(email)) {
          this.emailError = true
          return ''
        }
      }

      if (pwdinput.length < 6) {
        this.pwdError = true
        return ''
      }

      if (pwdinput !== retypePwdinput) {
        this.retypePwdError = true
        return ''
      }

      var sessionid = this.common.sessionidGet(this)
      var time = parseInt(new Date().getTime() / 1000)
      var dataJson = {
        'email': email,
        'password': pwdinput,
        'retypePassword': retypePwdinput,
        'time': time,
        'sessionid': sessionid,
        'operation': 'emailChangePassword',
        'searchsign': this.$route.query.sign ? this.$route.query.sign : '',
        'searchtime': this.$route.query.time ? this.$route.query.time : ''
      }
      var data = this.common.encryptionData(dataJson, this)
      emailChangePassword(data).then(res => {
        if (res.flag === '102') {
          this.$message({
            type: 'error',
            message: this.$t(res.msg)
          })
        } else if (res.flag !== '200') {
          this.passFail = true
        } else {
          // if (this.source === 'roompai') {
          //   this.$router.push({name: 'login'})
          // } else {
          //   this.$router.push({name: 'login', query: { 'source': this.source }})
          // }
          var newQuerys = this.common.linkEncode({'source': this.source}, 'obj')
          if (this.conver === 1 || this.conver === '1') {
            newQuerys = this.common.linkEncode({'source': this.source, 'conver': this.conver}, 'obj')
          }
          this.$router.push({name: 'login', params: {'querys': newQuerys}})
        }
      })
    },
    emailRetype: function () {
      var email = this.common.linkQuerys.email
      var searchtime = this.common.linkQuerys.time
      var searchsign = this.common.linkQuerys.sign
      if (searchsign === undefined) {
        return ''
      }

      var sessionid = this.common.sessionidGet(this)
      var time = parseInt(new Date().getTime() / 1000)
      var dataJson = {
        'email': email,
        'searchsign': searchsign,
        'searchtime': searchtime,
        'time': time,
        'sessionid': sessionid,
        'operation': 'emailRetype'
      }
      var data = this.common.encryptionData(dataJson, this)
      emailRetype(data).then(res => {
        if (res.flag !== '200') {
          this.passFail = true
        } else {
          this.inputEmail = res.data.email
        }
      })
    },
    bodyCloseMenus: function (node) {
      if (node.target.getAttribute('data-index') !== 'forget-button') {
        if (this.forget_send_show === true) {
          this.forget_send_show = false
        }
      }
    }
  }
}
</script>

<style scoped>
/deep/ .top-pc{margin-top: 60px;}
.forget-main{background-color: rgb(255, 241, 180);width:100%;min-height: 560px; margin:0 auto;height: 100vh;padding-top: 7%;}
.forget-info{width: 31%;min-height: 540px;margin: 0 auto;background-color: rgba(255, 255, 255, 1);border: none;-moz-box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.09803921568627451); -webkit-box-shadow: 0px 2px 12px rgb(0 0 0 / 10%);box-shadow: 0px 2px 12px rgb(0 0 0 / 10%);}
.forgettext{font-weight: 650;font-size: 24px; height: 60px;background-color: rgba(255, 255, 255, 0);box-sizing: border-box;border-bottom: 1px solid rgba(221, 223, 226, 1);}
.forget-form{margin:15px 0px; color:#606266;font-size: 14px;}
.forget-form input{ margin-top:10px;}
.forget_send{width: 100%;height: 44px; font-size:16px; background-color: rgba(79, 76, 76, 1);box-sizing: border-box;border: 1px solid rgba(79, 76, 76, 1);border-radius: 4px;-moz-box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.34901960784313724);-webkit-box-shadow: 5px 5px 5px rgb(0 0 0 / 35%);box-shadow: 5px 5px 5px rgb(0 0 0 / 35%);color: #FFFFFF;margin-top:30px;}
.forget_send:hover{background-color: rgb(252, 210, 5, 1);border-color: rgb(252, 210, 5, 1); color:rgb(79,76,76)}
.forget_send_active{width: 100%;height: 44px; font-size:16px; background-color: rgb(252, 210, 5, 1)!important;box-sizing: border-box;border: 1px solid rgba(79, 76, 76, 1)!important;border-radius: 4px;-moz-box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.34901960784313724)!important;-webkit-box-shadow: 5px 5px 5px rgb(0 0 0 / 35%)!important;border-color: rgb(252, 210, 5, 1)!important;box-shadow: 5px 5px 5px rgb(0 0 0 / 35%)!important;color: rgb(79,76,76)!important;margin-top:30px;}
.forget-other{ text-align:center;}
.forget-other a{ font-size:14px; color:#5392F9;text-decoration-line: none;}
.el-input.is-active .el-input__inner, .el-input__inner:focus{border-color:rgba(252,210,5,1);box-shadow:0px 0px 8px rgba(252,210,5);}
.codeError,.codeError:focus,.codeError:hover{background: inherit;background-color: rgba(255, 255, 255, 1);box-sizing: border-box;border: 2px solid rgba(225, 45, 45, 1);border-radius: 4px;-moz-box-shadow: none;-webkit-box-shadow: none;box-shadow: none;}
/deep/ .el-button:focus, .el-button:hover{color:rgb(79,76,76)!important;border-color:rgb(252, 210, 5, 1)!important;background-color:rgb(252, 210, 5, 1)!important;}

.login-remind{ border-width: 0px;height: 56px;background: inherit;background-color: rgba(240, 249, 235);border: none;border-radius: 4px;-moz-box-shadow: none;-webkit-box-shadow: none;box-shadow: none;}
.login-remindinfo{padding-right: 18px;display: flex;justify-content: center;align-items: center; line-height:56px;}
.login-remind-text{color: #67C23A;line-height: 20px; font-size:14px;display:inline-block;width:90%;}
.login-img{ margin: 18px;width: 18px;height: 18px;background-color: rgba(103, 194, 58, 1);border: none;border-radius: 15px;-moz-box-shadow: none;-webkit-box-shadow: none;box-shadow: none;text-align: center;line-height: normal;display:inline-block; margin-right:10px;}

.login-remind-faild{overflow: hidden;background: inherit;background-color: rgba(254, 240, 240, 1);border-width: 0px;height: 56px;border: none;border-radius: 4px;-moz-box-shadow: none;-webkit-box-shadow: none;box-shadow: none;}
.login-img-faild{margin: 18px;width: 18px;height: 18px;background-color: rgba(245, 108, 108, 1);border: none;border-radius: 15px;-moz-box-shadow: none;-webkit-box-shadow: none;box-shadow: none;text-align: center;line-height: normal;display:inline-block; margin-right:10px;}
.login-remind-text-faild{color: #F56C6C;line-height: 20px; font-size:14px;display:inline-block;width:90%;}
.login /deep/ .el-input__inner{padding: 0 45px 0 15px;}
.eye{height: 15px; width: 15px; position: absolute;top: 12.5px; right: 15px; cursor: pointer;}
@media screen and (min-width: 1001px) {
.forget-info{width: 500px;}
}
@media screen and (max-width: 1000px) {
.forget-info{width: 97%;}
}
</style>



// WEBPACK FOOTER //
// src/components/login/resetPassword.vue